export const getNHIRolesRows = (entityData) => {
  let rowsMap = [];
  if (entityData?.mongo_atlas_api_key_data?.roles) {
    for (const role of entityData?.mongo_atlas_api_key_data?.roles) {
      rowsMap.push({
        id: rowsMap.length + 1,
        role_name: role.name,
        source: "mongoatlas",
      });
    }
  }
  if (entityData?.atlassian_api_key_data?.scopes) {
    for (const scope of entityData?.atlassian_api_key_data?.scopes) {
      rowsMap.push({
        id: rowsMap.length + 1,
        role_name: scope,
        source: "atlassian",
      });
    }
  }
  if (entityData?.gitlab_access_token_data?.scopes) {
    for (const scope of entityData?.gitlab_access_token_data?.scopes) {
      rowsMap.push({
        id: rowsMap.length + 1,
        role_name: scope,
        source: "gitlab",
      });
    }
  }
  if (entityData?.jamf_api_key_data?.permissions) {
    for (const roleName in entityData.jamf_api_key_data.permissions) {
      rowsMap.push({
        id: rowsMap.length + 1,
        role_name: roleName,
        source: "jamf",
      });
    }
  }
  return rowsMap;
};
